import { Fragment, useEffect } from "react";
import Footer from "./static/footer";
import Contact from "./static/contact";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const SupportPage = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const currentUser = useSelector((state) => state.currentUser);
  useEffect(() => {
    if (currentUser?.IsAuthenticated) {
      navigate("/");
    }
  }, [currentUser, navigate]);

  return (
    <Fragment>
      <div className="home-page" style={{ width: "100%", height: "100%" }}>
        <div id="blog" className="blog-area ptb-100 bg-f9f9f9">
          <div className="container">
            <div
              className="saas-section-title"
              data-aos="fade-up"
              data-aos-duration="800"
              data-aos-once="true"
              data-aos-delay="100"
            >
              <h2>{t("support.support")}</h2>
              <div className="bar"></div>
              <div class="terms-container">
                <h1>{t("support.support1")}</h1>
                <p>{t("support.support2")}</p>
                <p>
                  {t("support.support3")}
                </p>

                <h2>{t("support.start")}</h2>

                <h3>{t("support.start2")}</h3>
                <p>
                  {t("support.start3")}
                </p>

                <h3>{t("support.create")}</h3>
                <ul>
                  <li>
                    {t("support.visit")}{" "}
                    <a href="https://intelligence.cerebro360.ai">
                      {t("support.visit1")}
                    </a>
                  </li>
                  <li>
                    {t("support.clickon")}<strong>{t("support.signup")}</strong>
                  </li>
                  <li>{t("support.fill")}</li>
                  <li>{t("support.login")}</li>
                </ul>

                <h3>{t("support.system")}</h3>
                <ul>
                  <li>
                    <strong>{t("support.web")}</strong> {t("support.web1")}
                  </li>
                  <li>
                    <strong>{t("support.operating")}</strong> {t("support.operating1")}
                  </li>
                  <li>
                    <strong>{t("support.internet")}</strong> {t("support.internet1")}
                  </li>
                </ul>

                <h3>{t("support.setup")}</h3>
                <ul>
                  <li>{t("support.setup1")}</li>
                  <li>{t("support.setup2")}</li>
                  <li>{t("support.setup3")}</li>
                </ul>

                <h2>{t("support.faq")}</h2>

                <h3>{t("support.faq1")}</h3>
                <p>
                  {t("support.faq2")}
                </p>

                <h3>{t("support.ai")}</h3>
                <p>
                  {t("support.ai1")}
                </p>

                <h3>{t("support.files")}</h3>
                <p>{t("support.files1")}</p>
                <ul>
                  <li>{t("support.files2")}</li>
                </ul>

                <h3>{t("support.data")}</h3>
                <p>
                  {t("support.data1")}
                </p>

                <h2>{t("support.guide")}</h2>

                <h3>{t("support.issues")}</h3>
                <ul>
                  <li>{t("support.issues1")}</li>
                  <li>
                    {t("support.reset")}{" "}
                    <strong>{t("support.reset1")}</strong>{t("support.reset2")}
                  </li>
                  <li>{t("support.clear")}</li>
                </ul>

                <h3>{t("support.api")}</h3>
                <ul>
                  <li>
                    {t("support.api1")}
                  </li>
                  <li>{t("support.api2")}</li>
                  <li>
                    {t("support.api3")}
                  </li>
                </ul>

                <h3>{t("support.errors")}</h3>
                <ul>
                  <li>{t("support.errors1")}</li>
                  <li>{t("support.errors2")}</li>
                  <li>{t("support.errors3")}</li>
                </ul>

                <h3>{t("support.performance")}</h3>
                <ul>
                  <li>{t("support.performance1")}</li>
                  <li>{t("support.performance2")}</li>
                  <li>{t("support.performance3")}</li>
                </ul>

                <h2>{t("support.contact")}</h2>
                <p>
                 {t("support.contact1")}
                </p>
                <ul>
                  <li>
                    <strong>{t("support.chat")}</strong> {t("support.chat1")}
                  </li>
                  <li>
                    <strong>{t("support.email")}</strong>{" "}
                    <a href="mailto:support@cerebro360.ai">
                      {t("support.email1")}
                    </a>
                  </li>
                </ul>
                <p>
                  <strong>
                    {t("support.urgent")}
                  </strong>
                </p>

                <p>
                  {t("support.thankyou")}
                </p>
              </div>
            </div>
          </div>
        </div>
        <Contact />
        <Footer />
      </div>

      <style>
        {`  
        .home-page h1, .home-page h2 {
            color: #333;
        }
        .home-page .terms-container {
            margin: 0 auto;
            background: #fff;
            padding: 20px;
            border-radius: 8px;
            text-align:left;
            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        }
        .home-page .terms-container ul {
            padding-left: 20px;
        }
        .home-page  .terms-container .contact {
            margin-top: 20px;
            font-weight: bold;
        }
        .home-page .terms-container p{
        max-width:unset;
        }

         .home-page .terms-container h2{
          max-width:unset;
         }
        
        `}
      </style>
    </Fragment>
  );
};
